import { Checkbox } from "primereact/checkbox";
import { capitalize } from "../helpers/helpers";

function Filter({ title, activeItems, onChange, isCapitalize = false }) {
    return (
        <div className="flex align-items-center">
            <Checkbox
                inputId={title}
                name="pizza"
                value="Cheese"
                onChange={() => {
                    // setIsChecked(!isChecked);
                    const newArr = [...activeItems];
                    const index = newArr.indexOf(title);

                    if (index > -1) {
                        newArr.splice(index, 1);
                    } else {
                        newArr.push(title);
                    }

                    onChange(newArr);
                }}
                checked={activeItems.includes(title)}
                className="border"
            />
            <label htmlFor={title} className="ml-2">
                {isCapitalize ? capitalize(title) : title}
            </label>
        </div>
    );
}

export default Filter;
